import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SuperStarForDropdown as SUPER_STAR_DROPDOWN } from "src/components/api/register_super_star/registerSuperStar";
import { PromotionalPartnerForDropdown as PROMOTIONAL_PARTNER_DROPDOWN } from "src/components/api/register_promotional_partner/registerPromotionalPartner";
import { ToastError, ToastSuccess } from '../uiElements/toast';
import { LOGOUT } from "src/components/helper/constants";
import AdminPageSessionClose from "src/components/util/adminPageSessionClose";
import { ProductCategoryForHomePage } from "src/components/api/register_product_category/registerProductCategory";

type RequestProps = {
    PromotionalPartnerMasterID: number;
    PromotionalPartner: string;
    SuperStarMasterID: number;
    SuperStarName: string;
    ImagePath: string;
};

type RequestCountryProps = {
    BannerType?: {
        id?: number | string;
        label: string;
        code?: string;
        icon?: string;
        phone?: string;
    } | null;
    BannerTypeID?: number;
};

const UseHeader = () => {
    const bannerOptions = [
        {
            id: 1,
            label: "India",
            code: "in",
            icon: "https://flagcdn.com/w40/in.png",
            phone: "91",
        },
        {
            id: 2,
            label: "United States",
            code: "us",
            icon: "https://flagcdn.com/w40/us.png",
            phone: "1",
        },
        {
            id: 3,
            label: "Australia",
            code: "au",
            icon: "https://flagcdn.com/w40/au.png",
            phone: "61",
        },
    ];

    const defaultBannerOption = bannerOptions.find((x) => x.id === 1) || null;

    const [superStarList, setSuperStarList] = React.useState([]);
    const [promotionalPartnerList, setPromotionalPartnerList] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectCategoryList, setSelectCategoryList] = useState([]);

    const defaultValues = {
        SuperStarMasterID: 0,
        PromotionalPartnerMasterID: 0,
        PromotionalPartner: "",
        SuperStarName: "",
        ImagePath: "",
        BannerType: defaultBannerOption,
        BannerTypeID: 1,
    };

    const validationSchema = Yup.object().shape({
        //TeamName: Yup.string().required("Team name is required"),
    });

    const formContext = useForm<RequestProps>({
        defaultValues,
        resolver: yupResolver(validationSchema) as any,
    });

    const { reset, setValue } = formContext;
    
    const formCountryContext = useForm<RequestCountryProps>({
        defaultValues,
        resolver: yupResolver(validationSchema) as any,
    });

    const {  } = formCountryContext;

    const resetForm = () => {
        reset({
            SuperStarName: "",
        });
        setIsUpdate(false);
    };

    useEffect(() => {
        selectSuperStar();
        selectPromotionalPartner();
        ProductCategoryList();
        AdminPageSessionClose();
    }, []);

    const ProductCategoryList = async () => {
        setSelectCategoryList([]);
        const response = await ProductCategoryForHomePage();
        if (!response?.isAuthorized) LOGOUT();
        if (!response?.status) {
          let failResult = JSON.parse(response?.data!);
          ToastError(failResult.Message);
          return;
        }
        var data = JSON.parse(response?.data!);
        setSelectCategoryList(data);
      };

    const selectSuperStar = async () => {
        setSuperStarList([]);
        const response = await SUPER_STAR_DROPDOWN();
        if (!response?.isAuthorized) LOGOUT();
        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }
        var data = JSON.parse(response?.data!);
        setSuperStarList(data);
        reset();
    };

    const selectPromotionalPartner = async () => {
        setPromotionalPartnerList([]);
        const response = await PROMOTIONAL_PARTNER_DROPDOWN();
        if (!response?.isAuthorized) LOGOUT();
        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }
        var data = JSON.parse(response?.data!);
        setPromotionalPartnerList(data);
        reset();
    };

    const onCountrySubmit: SubmitHandler<RequestProps> = async (values) => {
        let inputObj = {
        };
        let request = JSON.stringify(inputObj);
        setLoading(true);
    
        // var response =
        //   isUpdate === false ? await INSERT(request) : await UPDATE(request);
        // setLoading(false);
        // if (!response?.isAuthorized) LOGOUT();
        // if (!response?.status) {
        //   const failResult = JSON.parse(response?.data!);
        //   ToastError(failResult.Message);
        //   return;
        // }
        //const result = JSON.parse(response?.data!);
        //ToastSuccess(result.Message);
        reset();
        setIsUpdate(false);
        resetForm();
      };
    
      const onSubmit: SubmitHandler<RequestProps> = async (values) => {
        let inputObj = {
        };
        let request = JSON.stringify(inputObj);
        setLoading(true);
    
        // var response =
        //   isUpdate === false ? await INSERT(request) : await UPDATE(request);
        // setLoading(false);
        // if (!response?.isAuthorized) LOGOUT();
        // if (!response?.status) {
        //   const failResult = JSON.parse(response?.data!);
        //   ToastError(failResult.Message);
        //   return;
        // }
        //const result = JSON.parse(response?.data!);
        //ToastSuccess(result.Message);
        reset();
        setIsUpdate(false);
        resetForm();
      };

    return {
        superStarList,
        promotionalPartnerList,
        formContext,
        onSubmit,
        formCountryContext,
        onCountrySubmit,
        selectCategoryList,
    }
}

export default UseHeader;
